module.exports = __webpack_public_path__ + "img/7.aba4774c.jpg";